import { useState, useEffect, useRef } from 'react'
import { getModel, deleteModel, getModelAccount } from '../api'

export default function useModelDetail(id) {
  const [model, setModel] = useState(null)
  const [account, setAccount] = useState(null)
  const [loading, setLoading] = useState(true)
  const [loadingAccount, setLoadingAccount] = useState(false)
  const [error, setError] = useState('')
  const [deleting, setDeleting] = useState(false)
  const loadedModelIdRef = useRef(null)

  const profile = model?.profile ?? null

  function load() {
    if (!id) return
    setLoading(true)
    setError('')
    getModel(id)
      .then(setModel)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }

  function loadAccount() {
    if (!model?.id) return
    const hasOnlyfansapi = model?.provider_links?.some(
      (l) => l.provider === 'onlyfansapi' && l.connection_status === 'connected'
    )
    if (!hasOnlyfansapi) {
      setAccount(null)
      return
    }
    setLoadingAccount(true)
    getModelAccount(id)
      .then((r) => setAccount(r.data ?? r ?? null))
      .catch(() => setAccount(null))
      .finally(() => setLoadingAccount(false))
  }

  async function handleDelete() {
    setDeleting(true)
    setError('')
    try {
      await deleteModel(id)
      return true
    } catch (err) {
      setError(err.message)
      return false
    } finally {
      setDeleting(false)
    }
  }

  useEffect(() => {
    if (!id) return
    if (loadedModelIdRef.current === String(id)) return
    loadedModelIdRef.current = String(id)
    load()
  }, [id])

  useEffect(() => {
    if (model) loadAccount()
  }, [model?.id, model?.provider_links])

  return {
    model,
    profile,
    account,
    loading,
    loadingAccount,
    error,
    deleting,
    setModel,
    setError,
    load,
    loadAccount,
    handleDelete,
  }
}
